export default "__VITE_ASSET__7550f751__"